import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormInvoiceDelete() {
  const { setModal, setInvoice, getInvoice, deleteInvoices } =
    useContext(ExportContext)!.controllers.invoice;

  const [loading, setLoading] = useState(false);

  const selectedInvoice = getInvoice('selected.invoice');
  const selectedInvoices = getInvoice('selecteds.invoices');
  const invoiceIds =
    selectedInvoice !== -1 ? [selectedInvoice] : selectedInvoices;
  const length = invoiceIds.length;

  const close = () => {
    setModal('single.deleteInvoices', false);
    setInvoice('selected.invoice', -1);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteInvoices(invoiceIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir a invoice?'
            : `Tem certeza que deseja excluir ${length} invoices?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
